<template>
  <div class="app-container">
    <div class="app-content">
      <el-card class="meter-hourly-reading">
        <template #header>
          <el-form inline size="small">
            <el-form-item :label="$t('text.kssj')">
              <el-date-picker
                v-model="queryParams.starttime"
                type="date"
                :placeholder="$t('placeholder.xzrq')"
                value-format="yyyy-MM-dd 00:00:00"
              />
            </el-form-item>
            <el-form-item :label="$t('text.jssj')">
              <el-date-picker
                v-model="queryParams.endtime"
                type="date"
                :placeholder="$t('placeholder.xzrq')"
                value-format="yyyy-MM-dd 23:59:59"
              />
            </el-form-item>
            <el-form-item :label="$t('text.sbid')">
              <el-select v-model="queryParams.devid" :placeholder="$t('placeholder.xzid')">
                <el-option v-for="(item, index) in deviceList" :key="index" :label="item.key" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item label="是否乘倍率">
              <el-select v-model="queryParams.multiplyByTheMultiplier">
                <el-option label="未乘倍率" :value="false" />
                <el-option label="乘以倍率" :value="true" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                icon="el-icon-search"
                :loading="table.loading"
                @click="getMeterHourlyReading"
              >{{ $t('button.cx') }}</el-button>
              <el-button
                type="primary"
                icon="el-icon-download"
                :loading="table.loading ||table.exportLoading"
                @click="handleExport"
              >{{ $t('button.dc') }}</el-button>
            </el-form-item>
          </el-form>
        </template>
        <template #default>
          <p class="alart-message">
            <label style="color: red;">此表格为电表整点历史读数，当电表不支持读取时默认显示N/A</label>
          </p>
          <el-table
            v-loading="table.loading"
            :data="table.listData"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
            height="calc(100% - 1.5em)"
          >
            <el-table-column :label="$t('text.cjqxlh')" prop="gatewaySn" width="150px" />
            <el-table-column :label="$t('text.dbxlh')" prop="meterSn" width="150px" />
            <el-table-column :label="$t('text.shijian')" prop="hourTime" width="168px" :formatter="timeFormat" />

            <el-table-column label="正向尖" prop="fsharp" :formatter="readingFormat" />
            <el-table-column label="正向峰" prop="fpeak" :formatter="readingFormat" />
            <el-table-column label="正向平" prop="fflat" :formatter="readingFormat" />
            <el-table-column label="正向谷" prop="fvalley" :formatter="readingFormat" />
            <el-table-column label="正向深谷" prop="fdvalley" :formatter="readingFormat" />
            <el-table-column label="正向总" prop="ftotal" :formatter="readingFormat" />

            <el-table-column label="反向尖" prop="rsharp" :formatter="readingFormat" />
            <el-table-column label="反向峰" prop="rpeak" :formatter="readingFormat" />
            <el-table-column label="反向平" prop="rflat" :formatter="readingFormat" />
            <el-table-column label="反向谷" prop="rvalley" :formatter="readingFormat" />
            <el-table-column label="反向深谷" prop="rdvalley" :formatter="readingFormat" />
            <el-table-column label="反向总" prop="rtotal" :formatter="readingFormat" />
          </el-table>
        </template>
      </el-card>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs'
import { GetDevicesByOrgId } from '@/api/Universal'
import { QueryMeterHourlyReading, ExportMeterHourlyReading } from '@/api/Meter'
export default {
  name: 'MeterHourlyReading',
  components: {},
  data () {
    return {
      queryParams: {
        /** 电站主键 */
        orgid: this.$store.getters.station.id,
        /** 设备主键 */
        devid: '',
        /** 开始时间 */
        starttime: this.$parseTime(new Date(), 'yyyy-MM-dd 00:00:00'),
        /** 结束时间 */
        endtime: this.$parseTime(new Date(), 'yyyy-MM-dd 23:59:59'),
        /** 是否乘以倍率 */
        multiplyByTheMultiplier: false
      },
      table: {
        listData: [],
        loading: false,
        exportLoading: false
      },
      deviceList: [],
    }
  },
  computed: {

    /** 时间格式化 */
    timeFormat () {
      return (_row, _column, cellValue, _index) => {
        return dayjs(cellValue).format('YYYY-MM-DD HH:mm:ss')
      }
    },

    /** 读数格式化 */
    readingFormat () {
      return (_row, _column, cellValue, _index) => {
        return cellValue < 0 ? 'N/A' : cellValue
      }
    },
  },
  created () {
    this.getDeviceList().then(() => {
      this.getMeterHourlyReading()
    })
  },
  methods: {

    /** 获取设备列表 */
    getDeviceList () {
      return new Promise((resolve, reject) => {
        GetDevicesByOrgId({ id: this.$store.getters.station.id, tag: '3' }).then((res) => {
          this.deviceList = res.data || []
          if (!this.deviceList || this.deviceList.length === 0) {
            this.$message({
              type: 'error',
              message: '该电站下没有设备'
            })
            reject()
          } else {
            this.queryParams.devid = this.deviceList[0].value
            resolve()
          }
        }).catch(() => {
          reject()
        })
      })
    },

    /** 获取电表整点数据 */
    getMeterHourlyReading () {
      if (!this.queryParams.devid) {
        this.$message({
          type: 'warning',
          message: '请选择一个设备'
        })
        return
      }
      if (!this.queryParams.starttime || !this.queryParams.endtime) {
        this.$message({
          type: 'warning',
          message: '请选择时间范围'
        })
        return
      }
      this.table.loading = true
      const postParams = {
        orgid: this.queryParams.orgid,
        devid: this.queryParams.devid,
        starttime: this.queryParams.starttime,
        endtime: this.queryParams.endtime,
        multiplyByTheMultiplier: this.queryParams.multiplyByTheMultiplier,
      }
      QueryMeterHourlyReading(postParams).then(({ data }) => {
        this.table.listData = data || []
      }).finally(() => {
        this.table.loading = false
      })
    },

    /** 导出整点数据 */
    handleExport () {
      if (!this.queryParams.devid) {
        this.$message({
          type: 'warning',
          message: '请选择一个设备'
        })
        return
      }
      if (!this.queryParams.starttime || !this.queryParams.endtime) {
        this.$message({
          type: 'warning',
          message: '请选择时间范围'
        })
        return
      }
      const postParams = {
        orgid: this.queryParams.orgid,
        devid: this.queryParams.devid,
        starttime: this.queryParams.starttime,
        endtime: this.queryParams.endtime,
        multiplyByTheMultiplier: this.queryParams.multiplyByTheMultiplier,
      }
      this.table.exportLoading = true
      ExportMeterHourlyReading(postParams).then(res => {
        window.location.href = res.data
      }).finally(() => {
        this.table.exportLoading = false
      })
    }
  },
}
</script>
<style scoped>
.meter-hourly-reading {
   width: 100%;
   height: 100%;
   padding: 0px;
   box-sizing: border-box;
   background-color: var(--card-bg-color);
   border-color: var(--card-bg-color);
}
.meter-hourly-reading >>>.el-card__header{
  width: 100%;
  height: 50px;
  padding: 0px 10px;
  box-sizing: border-box;
}
.meter-hourly-reading >>>.el-card__header .el-form{
  width: 100%;
  height: 50px;
  padding: 0px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.meter-hourly-reading >>>.el-card__header .el-form .el-form-item{
  margin-bottom: 0px;
}

.meter-hourly-reading >>>.el-card__body{
  width: 100%;
  height: calc(100% - 50px);
  padding: 10px;
  box-sizing: border-box;
}
.meter-hourly-reading >>>.el-card__body .alart-message{
  width: 100%;
  height: 1.5em;
  display: flex;
  align-items: center;
}

</style>
